import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button } from '@mui/material';

interface EditMemoModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (memo: string) => void;
  initialMemo: string;
}

const EditMemoModal: React.FC<EditMemoModalProps> = ({ open, onClose, onSave, initialMemo }) => {
  const [memo, setMemo] = useState<string>(initialMemo || '');

  useEffect(() => {
    setMemo(initialMemo || '');
  }, [initialMemo]);

  const handleSave = () => {
    onSave(memo);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ p: 4, backgroundColor: 'white', margin: 'auto', marginTop: '10%', width: '50%' }}>
        <h2>メモを編集</h2>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
        />
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleSave}>
            送信
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditMemoModal;
